import { Skeleton } from '@tuic/web-compositions/core/Skeleton';
import { Fragment } from 'react';

import type { FC } from 'react';

/**
 * Streaming fallback for the cruise-price block. Mirrors the block layout:
 * the booking info list and the price table. Page chrome (header, padding) is
 * owned by the Prism page shell, so it is intentionally not rendered here.
 */
export const CruisePriceSkeleton: FC = () => (
  <div className="flex flex-col gap-12 md:gap-16 max-w-4xl">
    {/* Ihre Buchung */}
    <section>
      <div className="headline-lg mb-8 max-w-[12rem]">
        <Skeleton className="h-[1lh] w-48" />
      </div>
      <dl className="grid grid-cols-2 gap-2 max-w-[28rem] text-lg">
        {Array.from({ length: 5 }).map((_, index) => (
          <Fragment key={index}>
            <dt>
              <Skeleton className="h-[1lh] w-5/6" />
            </dt>
            <dd className="m-0">
              <Skeleton className="h-[1lh] w-5/6" />
            </dd>
          </Fragment>
        ))}
      </dl>
    </section>

    {/* Reisepreis (one line item) */}
    <section>
      <div className="headline-lg mb-10 max-w-[12rem]">
        <Skeleton className="h-[1lh] w-48" />
      </div>

      <div className="text-lg">
        <div className="grid grid-cols-[1fr_auto] gap-x-4 sm:grid-cols-[2fr_2fr_1fr]">
          <div className="flex flex-col gap-y-1">
            <Skeleton className="h-[1lh] w-4/5" />
            <Skeleton className="h-[1lh] w-4/5" />
          </div>
          <div className="col-start-1 row-start-2 mt-2 flex flex-col gap-y-1 sm:col-start-2 sm:row-start-1 sm:mt-0">
            <Skeleton className="h-[1lh] w-4/5" />
            <Skeleton className="h-[1lh] w-4/5" />
          </div>
          <div className="col-start-2 row-start-1 flex flex-col items-end sm:col-start-3">
            <Skeleton className="h-[1lh] w-20" />
          </div>
        </div>

        <div className="my-6 h-px bg-stroke-secondary-40" />

        <div className="flex justify-between">
          <Skeleton className="h-[1lh] w-25" />
          <Skeleton className="h-[1lh] w-20" />
        </div>
      </div>
    </section>
  </div>
);
